import { Component, computed, inject } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { MatButtonModule } from '@angular/material/button';
import { MatDivider } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@suvo-bi-core';

@Component({
  standalone: true,
  imports: [MatButtonModule, MatDivider, MatIconModule, MatMenuModule, RouterModule],
  selector: 'app-account-widget',
  template: `
    <button mat-stroked-button color="primary" class="account-button" [matMenuTriggerFor]="menu">
      <mat-icon>person</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <div mat-menu-item disabled style="text-align: center; opacity: 80%">
        {{ displayName() || 'My Account' }}
      </div>
      <mat-divider />
      <a mat-menu-item routerLink="/private/account">
        <mat-icon color="primary">person</mat-icon>
        My Account
      </a>
      <button mat-menu-item (click)="logout()">
        <mat-icon color="primary">logout</mat-icon>
        Logout
      </button>
    </mat-menu>
  `,
  styles: [
    `
      .account-button {
        border-radius: 999px;
        width: 42px;
        height: 42px;
        min-width: auto;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }

      .account-button mat-icon {
        margin: 0 !important;
      }
    `,
  ],
})
export class AccountWidgetSelectorComponent {
  private readonly authService = inject(AuthService);
  private readonly fireAuth = inject(AngularFireAuth);
  private readonly router = inject(Router);

  readonly displayName = computed(() => this.authService.currentUser()?.displayName);
  async logout() {
    await this.fireAuth.signOut();
    await this.router.navigate(['/']);
  }
}
